module.exports = __webpack_public_path__ + "static/dnk-4be25e8026cf2510c935b9598a61594a.webp";